import AWS from 'aws-sdk'

export const uploadFile = ({ accessKeyId, secretAccessKey, sessionToken, objectKey, bucketName }, file) => {

    AWS.config.credentials = new AWS.Credentials(accessKeyId, secretAccessKey, sessionToken);
    AWS.config.update({region: 'ap-south-1'});
    var upload = new AWS.S3.ManagedUpload({
        partSize: 5 * 1024 * 1024,
        params: {
            Body: file,
            Bucket: bucketName,
            Key: objectKey,
            ACL: "public-read"
        }
    });

    return upload.promise().then(data => data).catch(error => ({message: error.message}));
}